import '../evento.css';
import { Form, Input, Button, Layout, Row, Col,notification, Modal, Checkbox, Select,ConfigProvider, Divider, Collapse,Radio ,Spin, Popover,Space, Card  } from 'antd';
import { CheckOutlined, PlusOutlined, MinusCircleOutlined} from '@ant-design/icons';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import axios from "axios";
import es_ES from 'antd/lib/locale/es_ES';
import countries from '../../static/json/countries.json'
import {NavLink} from "react-router-dom";
import Foot from "../components/Footer"
import {IP,getCountryCode} from '../components/utils';
import UserMenu from "../components/UserMenu"
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import WordCounter from '../components/WordCounter';
import { withTranslation  } from 'react-i18next';

class Inscription extends Component {
  constructor(props){
    super(props)
    this.state={
      phone: '',
      sended: false,
      showRegistrate: false,
      genres:[],
      fileList: [],
      fileListAuth: [],
      authors:[],
      isBusy:false,
      genreSelected:false,
      portugueseGenre:false,
      hideCountry:{}
    }
  }

  async componentWillMount() {
    // const plays = await fetch(IP + 'api/culturasOriginarias/obra/',{//this is to validate that is logued, since the award has already benn closed and it is necessary to be admin to register another conc
    //   method: "get",
    //   credentials: "same-origin",
    //   headers: {
    //     "Authorization": localStorage.getItem("Authorization") ,
    //     "Accept": "application/json",
    //     "Content-Type": "application/json"
    //   },
    // });
    // const json_plays = await plays.json();
    // if(json_plays['detail']){
    //   localStorage.clear()
    //   window.location.reload(); 
    // }
    // const response = await fetch(IP + 'api/casa/genero/');
    // const json = await response.json();
    // this.setState({ genres: json });
  }
  render() {
    const { Content } = Layout;
    const { Option } = Select;
    const { fileList,fileListAuth } = this.state;
    const { Panel } = Collapse;
    const t = this.props.t
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    };
    
    const validateMessages =  {
      required: '${label} es requerido!',
      types: {
        email: '${label} no es un email válido!',
        number: '${label} no es un número válido!',
      },
      number: {
        range: '${label} must be between ${min} and ${max}',
      },
    }

    const customRequest = (form) => {
      console.log("FORM",form)
    
      const data= new FormData()
      var autores =  JSON.parse(JSON.stringify(form['autores'])); 

      for(var aut in  form['autores']){

        console.log("PAIS", form['autores'][aut]['pais'],getCountryCode(form['autores'][aut]['pais']))

        form['autores'][aut]['tel'] = '+' + form['autores'][aut]['tel'] 

          form['autores'][aut]['pais'] = getCountryCode(form['autores'][aut]['pais'])
          
          
          form['autores'][aut]['whatsapp'] = "0" in form['autores'][aut]['redes']
          form['autores'][aut]['telegram'] = "1" in form['autores'][aut]['redes']
          form['autores'][aut]['signal'] = "2" in form['autores'][aut]['redes']

          
        console.log("AUT",form['autores'][aut])
      }
    
      for ( var key in form ) {
        if(key =='autores'){
          data.append(key,JSON.stringify( form[key]));
          
        }
        else{
          data.append(key, form[key]);
        }
    }
    data.append('premio',3)
    this.setState({isBusy:true},()=>axios.post(IP + 'api/culturasOriginarias/register/ponencia', data).then((res) => {
      if (res.status == 200){
        this.setState({isBusy:false})
        Modal.success({
          content: 'Gracias por registrarse en el evento',
          onOk:()=> window.open("/culturasOriginarias/registro/ponencia","_self")
        });
      } ;
    }).catch((err) => {
        this.setState({isBusy:false})
        form.autores = autores
        notification.error({
          message:'Error',
          description:err.response.data.non_field_errors,
        });
      }))
  }
    const checkBoxChange = e =>{
      this.setState({showRegistrate:e.target.checked})
    }

    const uploadProps = {
      onRemove: file => {
        this.setState(state => {
          const index = this.state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState({
          fileList: [file],
        });
        return false;
      },
      fileList,
    };
    const uploadPropsAuth = {
      onRemove: file => {
        this.setState(state => {
          const index = this.state.fileListAuth.indexOf(file);
          const newFileList = state.fileListAuth.slice();
          newFileList.splice(index, 1);
          return {
            fileListAuth: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState({
          fileListAuth: [file],
        });
        return false;
      },
      fileListAuth,
    };
    return (
      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
              <UserMenu showOnlyLanguage/>
          
              <Row justify="start" align="middle">
                <Col span={24}>
                  <div style={{textAlign: 'center', fontWeight:'bold'}}> <Col span={24}><h1 className='title' style={{color:"black"}}>{t("Inscripción")}</h1></Col></div>
                </Col>
              </Row>
              <Spin spinning={this.state.isBusy} >
                <Content>

                  <Row  justify="center" align="middle" >
                    <Col span={24}>
                      <Form {...formItemLayout} id='regForm' name="nest-messages" onFinish={customRequest} validateMessages={validateMessages} layout = 'horizontal' initialValues={{autores:[""]}}>
                        <Row  justify="center" align="middle" >
                          <Col xs={{span:24, offset:0 }}sm={{span:24, offset:0 }}>
                            <Divider style={{fontWeight:'bold', width:10, fontSize:'medium'}} >{t("PONENCIA")}</Divider>
                                <Card>
                                  <Row  justify="center" align="left" >
                                    <Col xs={{span:24, offset:2}}sm={{span:10}}>
                                      <h3 >{t("Ponencia")}</h3> 
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item  name={'titulo'} fieldKey={'titulo'} label={t("Título")} rules={[{ required: true }]}>
                                        <Input className='originarias-input' style={{width:'80%'}}/>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item name={'resumen'} label={t("Resumen")} rules={[{ required: true }]}>
                                        <WordCounter/>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                 
                                  <Form.List name={'autores'} style={{align:"left"}}>
                              {(autores, { add, remove }) => (
                              <>
                                {autores.map((autor,index2) =>( 
                                <>
                                  <Row  justify="center" align="left" >
                                    <Col xs={{span:24, offset:2}}sm={{span:10}}>
                                      <h4>{autores.length==1?t("Autor"): t("Autor") + " " + (index2+1)} </h4> 
                                    </Col>
                                  </Row>

                                  

                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[autor.name, 'nombre']}  label={t("Nombre")} rules={[{ required: true }]}>
                                        <Input className='originarias-input' style={{width:'80%'}}/>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[autor.name, 'apellidos']}  label={t("Apellidos")} rules={[{ required: true }]}>
                                        <Input className='originarias-input' style={{width:'80%'}}/>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[autor.name, 'pronombre']} label={t("Pronombre")} rules={[{  required: true }]}>
                                        <Radio.Group >
                                          <Radio value={0}>{t("Él")}</Radio>
                                          <Radio value={1}>{t("Ella")}</Radio>
                                          <Radio value={2}>{t("Elle")}</Radio>
                                        </Radio.Group>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                      
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[autor.name,'pais']} label={t("País")}  rules={[{ required: true }]}>
                                        <Select style={{width:'80%'}} showSearch className='originarias-select'>
                                          {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                            return <Option value={obj["name_es"]}>{obj["name_es"]}</Option>
                                            })}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[autor.name, 'pueblo']}  label={t("Pueblo o nación indígena")} rules={[{ required: false }]}>
                                        <Input className='originarias-input' disabled={this.state.hideCountry.c} style={{width:'80%'}}/>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[autor.name, 'organizacion']}  label={t("Organización,institución, proyecto o colectivo")} rules={[{ required: true }]}>
                                        <Input className='originarias-input' style={{width:'80%'}}/>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[autor.name, 'email']} label={t("Correo electrónico")} rules={[{ type: 'email',  required: true }]}>
                                        <Input className='originarias-input' style={{width:'80%'}} />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2}}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[ autor.name,'tel']} label={t("Teléfono")} rules={[{ required: true }]}>
                                        <PhoneInput
                                          localization={es}
                                          country={'cu'}
                                          enableSearch={true}
                                          searchPlaceholder="Buscar"
                                          value={this.state.phone}
                                          autoFocus= {true}
                                          onChange={phone => this.setState({ phone })}
                                          placeholder ={"Número de teléfono"}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[autor.name, 'redes']} label={t("Redes")} rules={[{  required: true }]}>
                                          
                                      <Checkbox.Group style={{ width: '100%' }}>
                                              <Row>
                                                <Col span={8}>
                                                  <Checkbox value="0">WhatsApp</Checkbox>
                                                </Col>
                                                <Col span={8}>
                                                  <Checkbox value="1">Telegram</Checkbox>
                                                </Col>
                                                <Col span={8}>
                                                  <Checkbox value="2">Signal</Checkbox>
                                                </Col>
                                              </Row>
                                            </Checkbox.Group>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                        
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[ autor.name,'sintesis']} label={t("Ficha biográfica")} rules={[{ required: true }]}>
                                        <WordCounter/>
                                      </Form.Item>
                                    </Col>
                                  </Row>

                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...autor} name={[autor.name, 'participacion']} label={t("Tipo de participación")} rules={[{  required: true }]}>
                                        <Radio.Group >
                                          <Radio value={0}>{t("Presencial")}</Radio>
                                          <Radio value={1}>{t("Virtual")}</Radio>
                                        </Radio.Group>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                 
                                  
                                 
                                  {autores.length != index2 + 1 && <br/>}
                                  {autores.length == index2 + 1 &&
                                    <Row  justify="center" align="middle" >
                                      <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                                        <Form.Item >
                                          { index2 < 2 && <Button type="dashed" onClick={() => add()}  icon={<PlusOutlined />} style={{color:'#ef8031' }}>
                                          {t("Añadir autor")}
                                          </Button>}
                                          { index2 >0 &&
                                            <Button type="dashed" onClick={() => remove(autor.name)}  icon={<MinusCircleOutlined />} style={{color:'#ef8031' }}>
                                            {t("Eliminar autor")}
                                            </Button> 
                                          }
                                        </Form.Item>
                                      </Col>
                                    </Row>}
                                  </>
                                ))}
                              </>
                            )}
                          </Form.List>


                          </Card>
                        </Col>
                      </Row>
                     
                     
                     
                      

   
                       <Row  justify="center" align="middle" >
                        <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                          <Form.Item  >
                            <Checkbox onChange={checkBoxChange}>
                            {t("Acepto los")} <NavLink to="/terminos" >{t("Términos y condiciones de uso")}</NavLink>
                            </Checkbox><br/>
                            <br></br>
                            <Button icon={<CheckOutlined/>} style={{backgroundColor:'#ef8031',borderColor:'#F4A460', margin:'auto'}}type="primary" htmlType="submit" size='small' disabled={!this.state.showRegistrate}>
                            {t("Registrarse")}
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
  
                      
                    </Form>
                  </Col>
                </Row>
              </Content>
            </Spin>
          </Layout>
        </ConfigProvider>
    </div>
      <Foot/>
    </div>
    );
  }
}
export default withTranslation() (Inscription);


